import { render, staticRenderFns } from "./MaskBorderCustoms.vue?vue&type=template&id=b185b3ca"
import script from "./MaskBorderCustoms.vue?vue&type=script&lang=js"
export * from "./MaskBorderCustoms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports